import classnames from 'classnames';
import React from 'react';

import { type ButtonProps } from './types';

export default function Button({
  children,
  url,
  variant = 'primary',
  size = 'medium',
  fullWidth = false,
  className,
  ...props
}: ButtonProps) {
  const content = children;

  if (!content) return null;

  const buttonClasses = classnames(
    'interact-button',
    `button--${variant}`,
    `button--${size}`,
    fullWidth && 'button--full-width',
    className,
  );

  if (url) {
    return (
      <a
        href={url}
        className={buttonClasses}
        {...(props as React.AnchorHTMLAttributes<HTMLAnchorElement>)}
      >
        {content}
      </a>
    );
  }

  return (
    <button
      type="button"
      className={buttonClasses}
      {...(props as React.ButtonHTMLAttributes<HTMLButtonElement>)}
    >
      {content}
    </button>
  );
}
